var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageRatio3X4Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 8,
    fill: "#E7F0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 24,
    height: 34,
    rx: 2,
    fill: "#116DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRatio3X4Active);
export default __webpack_public_path__ + "static/media/image_ratio_3x4_active.203130aa496021bb12b2a5547960ade6.svg";
export { ForwardRef as ReactComponent };